module.exports = __webpack_public_path__ + "img/PearsonLogo_Horizontal_Blk_RGB.437d6a60.png";